import { Button, ButtonGroup } from '@chakra-ui/react';
import { type FC } from 'react';
import cx from 'classnames';
import { ActionType } from '../../GlobalContextProvider/global-reducer';
import { getEventFactory } from '../../../utils/get-event-factory';
import { Event, Feature, type Page } from '../../../types';
import { JobTypes } from '../../../types';
import { translate } from '../../../constants/translation';
import { useDispatch, useTripsContext } from '../../GlobalContextProvider/GlobalContextProvider';
import { useAppInsights } from '../../../hooks/useAppInsights';
import { getOldAndNewFilters } from '../../GlobalContextProvider/utils/filters-utils';

interface Props {
  page: Page;
}

const JobTypeSelector: FC<Props> = ({ page }) => {
  const context = useTripsContext();
  const { jobType } = context;
  const tripsDispatch = useDispatch();
  const appInsights = useAppInsights();
  const applyFilterHandler = (value: JobTypes): void => {
    const filters = getOldAndNewFilters(context, { jobType: value });
    tripsDispatch({
      type: ActionType.UPDATE_JOB_TYPE,
      payload: value,
    });
    appInsights.trackAnalyticsEvent(
      getEventFactory(Event.FilteredCompetitors)(Feature.TripsHistoryPanel, page, filters.old, filters.new)
    );
  };
  return (
    <ButtonGroup spacing="0" isAttached className="job-type-selector">
      <Button
        variant="secondary"
        width="100%"
        className={cx({ 'selected-secondary-btn': jobType === JobTypes.all })}
        onClick={() => {
          applyFilterHandler(JobTypes.all);
        }}
      >
        {translate('ALL_TRIPS')}
      </Button>
      <Button
        variant="secondary"
        width="100%"
        className={cx({ 'selected-secondary-btn': jobType === JobTypes.svitzerTrip })}
        onClick={() => {
          applyFilterHandler(JobTypes.svitzerTrip);
        }}
      >
        {translate('SVITZER')}
      </Button>
      <Button
        variant="secondary"
        width="100%"
        className={cx({ 'selected-secondary-btn': jobType === JobTypes.competitorTrip })}
        onClick={() => {
          applyFilterHandler(JobTypes.competitorTrip);
        }}
      >
        {translate('OTHER')}
      </Button>
    </ButtonGroup>
  );
};

export default JobTypeSelector;
